import {
  SET_SERVICE_UI_FLAG,
  CLEAR_SERVICES,
  SET_SERVICES,
  SET_SERVICE_ITEM,
  EDIT_SERVICE,
  DELETE_SERVICE,
} from './types';

export const mutations = {
  [SET_SERVICE_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [CLEAR_SERVICES]: $state => {
    $state.records = {};
  },

  [SET_SERVICES]: ($state, data) => {
    const updatedRecords = { ...$state.records };
    data.forEach(service => {
      updatedRecords[service.id] = {
        ...(updatedRecords[service.id] || {}),
        ...service,
      };
    });
    $state.records = updatedRecords;
  },

  [SET_SERVICE_ITEM]: ($state, data) => {
    $state.records = {
      ...$state.records,
      [data.id]: {
        ...($state.records[data.id] || {}),
        ...data,
      },
    };
  },

  [EDIT_SERVICE]: ($state, data) => {
    $state.records = {
      ...$state.records,
      [data.id]: data,
    };
  },

  [DELETE_SERVICE]: ($state, serviceId) => {
    const { [serviceId]: toDelete, ...records } = $state.records;
    $state.records = records;
  },
};

